import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';
import { getCurrentUser } from '@vantiva-sa/homesight_humaui/Store/authStore';
import { getUserConfig } from '@vantiva-sa/homesight_humaui/Store/dataStore';
import { DIAGNOSTICS_ENDPOINTS, DIAGNOSTICS_TIMEOUTS, isDiagnosticsEnabled } from './config/endpoints';
import { checkReachability } from './services/ReachabilityService';

// Tier 1: silent, time-boxed probe that writes a health snapshot on portal load.
const PassiveHealthProbe = () => {
  const currentUser = useSelector(getCurrentUser);
  const userConfig = useSelector(getUserConfig(currentUser?.useruuid));
  const enabled = isDiagnosticsEnabled(userConfig);

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;

    const runProbe = async () => {
      try {
        const reachability = await checkReachability({
          endpoints: DIAGNOSTICS_ENDPOINTS,
          timeoutMs: DIAGNOSTICS_TIMEOUTS.request,
        });
        if (cancelled) return;
        if (!DIAGNOSTICS_ENDPOINTS.healthTelemetry) return;
        fetch(DIAGNOSTICS_ENDPOINTS.healthTelemetry, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            schemaVersion: '1.0',
            sessionId: uuid(),
            accountId: currentUser?.useruuid || null,
            capturedAt: new Date().toISOString(),
            reachability,
            browser: typeof navigator !== 'undefined' ? navigator.userAgent : null,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          }),
        }).catch(() => undefined);
      } catch (error) {
        // Tier 1 must never surface an error to the user.
        console.debug('Passive diagnostics probe failed', error);
      }
    };

    runProbe();
    return () => {
      cancelled = true;
    };
  }, [enabled, currentUser?.useruuid]);

  return null;
};

export default PassiveHealthProbe;
